import Tooltip from "@mui/material/Tooltip"
import Fade from "@mui/material/Fade"
import Zoom from "@mui/material/Zoom"
import Grow from "@mui/material/Grow"

const _transitionFactory = (name) => ({ fade: Fade, zoom: Zoom, grow: Grow })[name] || null
const _noTooltip = (title) => (title || null) === null

export default function TooltipSeeker({ title, transition = "fade", useLight = false, children, ...props }) {
    const myProps = {
        title: title || "",
        placement: "top",
        arrow: true,
        TransitionComponent: _transitionFactory(transition),
        TransitionProps: { timeout: 600 },
        disableFocusListener: _noTooltip(title),
        disableHoverListener: _noTooltip(title),
        disableInteractive: _noTooltip(title),
        disableTouchListener: _noTooltip(title),
        ...props,
        componentsProps: {
            ...props?.componentsProps,
            arrow: {
                ...props?.componentsProps?.arrow,
                sx: {
                    ...(useLight && { color: "background.paper" }),
                    ...props?.componentsProps?.arrow?.sx,
                },
            },
            tooltip: {
                ...props?.componentsProps?.tooltip,
                sx: {
                    ...(useLight && {
                        backgroundColor: "background.paper",
                        color: "text.primary",
                        boxShadow: "0px 0px 10px 1px rgba(219,219,219,1)",
                    }),
                    ...props?.sx,
                    ...props?.componentsProps?.tooltip?.sx,
                },
            },
        },
        PopperProps: {
            ...props?.PopperProps,
            ...(props?.offset && {
                modifiers: [{ name: "offset", options: { offset: props.offset } }],
            }),
        },
    }
    return <Tooltip {...myProps}>{children}</Tooltip>
}
